import { useState } from 'react'
import { heroVariants, HeroVariant, HeroVariantKey } from '../data/landing'

export function useHeroVariant(): HeroVariant {
  const [variant] = useState<HeroVariant>(() => {
    if (typeof window === 'undefined') return heroVariants.A
    const param = new URLSearchParams(window.location.search).get('v')?.trim().toUpperCase()
    return param && param in heroVariants ? heroVariants[param as HeroVariantKey] : heroVariants.A
  })
  return variant
}
